import sanityClient from "@sanity/client"

const db: string = import.meta.env.VITE_CMS_DATASET

export default sanityClient({
    projectId: "dgz9tpsd",
    dataset: db,
    useCdn: true,
    apiVersion: "2021-10-21",
})
